import React from "react";
import { useSelector } from 'react-redux';
import { useIntl } from 'react-intl';
import moment from "moment-timezone";
//Icons
import { Icon } from '@mui/material';

//Components
import { IconButton, Button, Tooltip } from '@gpstrackit/gtc-react-controls'
import Loading from './Loading';

//Helpers
import { GetFormatForMoment } from 'Core/data/Helpers';
import { endpoints } from 'Core/defaultValues';
import { useSupportChatAvailable } from 'Modules/.common/hooks/useSupportChatAvailable';
const ConnectionHistory = ({ openChat }) => {
    const { messages, locale } = useIntl();

    const {
        loadingsimCardSessionValidation,
        loadingInstallationValidation,
        simCardSessionValidation,
        loadingSimCardValidation,
        installationValidation,
        simCardValidation,
        attValidation,
        unitDetail,
    } = useSelector(state => state.troubleshootDeviceRedux);
    const { user } = useSelector(state => state.securityRedux);
    const supportChatAvailable = useSupportChatAvailable();

    const openTrobleshooting = () => {
        window.open(endpoints.TROUBLESHOOTING_URL, "_blank")
    }

    const formatDateWithTimezone = (dateString, format, extra) => {
        const date = moment(dateString);
        const timezone = unitDetail?.timeZone?.title
        const isUTCFormat = dateString.includes('Z');

        const inputFormat = isUTCFormat ? 'YYYY-MM-DDTHH:mm:ss.SSS[Z]' : 'YYYY-MM-DD HH:mm:ss.SSSZ';

        const selectedTimezone = timezone || moment.tz.guess();

        const formattedDate = moment(date, inputFormat).tz(selectedTimezone);

        return formattedDate.format(`${GetFormatForMoment(format)} ${extra || ''}`);
    };

    const calculateTimeDifference = (dateString, language) => {
        let date = new Date(dateString)
        let now = new Date()
        const timezone = unitDetail?.timeZone?.title
        date = moment.tz(date, 'YYYY-MM-DD HH:mm', timezone)
        now = moment.tz(now, 'YYYY-MM-DD HH:mm', timezone);

        const diffInMinutes = now.diff(date, 'minutes');
        if (diffInMinutes < 60) {
            return language === "en" ? `${diffInMinutes} min(s) ago` : `hace ${diffInMinutes} min(s)`
        } else if (diffInMinutes < 1440) {
            const diffInHours = Math.floor(diffInMinutes / 60);
            return language === "en" ? `${diffInHours} hr(s) ago` : `hace ${diffInHours} hr(s)`
        } else if (diffInMinutes < 43800) {
            const diffInDays = Math.floor(diffInMinutes / 1440);
            return language === "en" ? `${diffInDays} day(s) ago` : `hace ${diffInDays} día(s)`;
        } else if (diffInMinutes >= 43800) {
            const diffInMonths = Math.floor(diffInMinutes / 43200);
            return language === "en" ? `${diffInMonths} month(s) ago` : `hace ${diffInMonths} mes(es)`;
        }
    };

    return (
        <div className="connection-history">
            {
                installationValidation?.error ? (
                    <div className="connection-history-error">
                        <div className="connection-history-error-title">
                            <Icon className="icon-title">error</Icon>
                            <span>{messages['troubleshootDevice_noInstallationHistory']}</span>
                        </div>
                        <div className="connection-history-error-message">
                            <p>
                                {messages['troubleshootDevice_recommendedSteps']}
                                <IconButton
                                    className="icon-message"
                                    onClick={(e) => {
                                        if (e) e.preventDefault();
                                        openTrobleshooting()
                                    }}
                                    size="small"
                                    icon="open_in_new"
                                />
                            </p>
                        </div>
                        <div className="connection-history-error-button">
                            <Tooltip
                                title={supportChatAvailable
                                    ? messages["header_chatEnabled"]
                                    : messages["header_chatDisabeld"]}
                            >
                                <Button
                                    variant='primary'
                                    onClick={(e) => {
                                        if (e) e.preventDefault();
                                        openChat && openChat();
                                    }}
                                >
                                    {messages['troubleshootDevice_supportChat']}
                                </Button>
                            </Tooltip>
                        </div>
                    </div>
                ) : (
                    <div className="connection-history-general">
                        <div className="connection-history-general-installation">
                            {
                                loadingInstallationValidation ? (
                                    <Loading title={messages['troubleshootDevice_confirmingInstallation']} />
                                ) : (
                                    <>
                                        <div className="connection-history-general-installation-title">
                                            <Icon
                                                style={{ marginRight: 5, color: installationValidation?.data?.installed && "#66bb6a" }}
                                            >
                                                {installationValidation?.data?.installed ? "check_circle" : "radio_button_unchecked"}
                                            </Icon>
                                            <span>{messages['troubleshootDevice_installationHistory']}</span>
                                        </div>
                                        {
                                            installationValidation?.data?.installedOn && (
                                                <span className="connection-history-general-installation-label">{messages['troubleshootDevice_installedOn']}: <>{formatDateWithTimezone(installationValidation?.data?.installedOn, user?.dateformat)}</></span>
                                            )
                                        }
                                    </>
                                )
                            }
                        </div>
                        {
                            attValidation && (
                                <div className="connection-history-general-simcard">
                                    {
                                        loadingSimCardValidation || loadingsimCardSessionValidation ? (
                                            <Loading title={messages['troubleshootDevice_checkingCellularConnection']} />
                                        ) : (
                                            <div>
                                                <div className="connection-history-general-simcard-title">
                                                    <Icon
                                                        style={{
                                                            marginRight: 5,
                                                            color: (simCardValidation?.error || simCardSessionValidation?.error) ? "#FF6624" : (simCardValidation?.data || simCardSessionValidation?.data) ? "#66BB6A" : "#252525"
                                                        }}
                                                    >
                                                        {
                                                            (simCardValidation?.error || simCardSessionValidation?.error) ? "error" : (simCardValidation?.data || simCardSessionValidation?.data) ? "check_circle" : "radio_button_unchecked"
                                                        }
                                                    </Icon>
                                                    <span>{messages['troubleshootDevice_cellularHistory']}</span>
                                                </div>
                                                <div className="connection-history-general-simcard-description">
                                                    {/* <div>
                                                        <span>
                                                            {messages['troubleshootDevice_lastSession']}:
                                                            {simCardSessionValidation?.data?.dateSessionEnded ? ` ${formatDateWithTimezone(simCardSessionValidation?.data?.dateSessionEnded, `${user?.dateformat}`, "HH:mm")} - ` : ''}
                                                            {simCardSessionValidation?.data?.dateSessionStarted && !simCardSessionValidation?.data?.dateSessionEnded ? ` ${formatDateWithTimezone(simCardSessionValidation?.data?.dateSessionStarted, `${user?.dateformat}`, "HH:mm")} - ` : ''}
                                                        </span>
                                                        {simCardSessionValidation?.data?.dateSessionEnded && <strong>{calculateTimeDifference(simCardSessionValidation?.data?.dateSessionEnded, locale)}</strong>}
                                                        {simCardSessionValidation?.data?.dateSessionStarted && !simCardSessionValidation?.data?.dateSessionEnded && <strong>{calculateTimeDifference(simCardSessionValidation?.data?.dateSessionStarted, locale)}</strong>}
                                                    </div> */}
                                                    <span>{messages['troubleshootDevice_lastStatus']}: {simCardSessionValidation?.data?.status || ''}</span>
                                                </div>
                                            </div>
                                        )
                                    }
                                    {
                                        !loadingsimCardSessionValidation && simCardValidation?.error /* || simCardSessionValidation?.data?.exceededLimit */ && (
                                            <div className="connection-history-general-simcard-exceeded-limit">
                                                <p>
                                                    {messages['troubleshootDevice_connectivityIssuesMessage']}
                                                    <IconButton
                                                        className="icon-message"
                                                        size="small"
                                                        icon="open_in_new"
                                                        onClick={(e) => {
                                                            if (e) e.preventDefault();
                                                            openTrobleshooting();
                                                        }}
                                                    />
                                                </p>
                                                <div style={{ display: 'flex', justifyContent: 'center', marginTop: 30 }}>
                                                    <Tooltip
                                                        title={supportChatAvailable
                                                            ? messages["header_chatEnabled"]
                                                            : messages["header_chatDisabeld"]}
                                                    >
                                                        <Button
                                                            onClick={(e) => {
                                                                if (e) e.preventDefault();
                                                                openChat && openChat();
                                                            }}
                                                            variant='primary'
                                                        >
                                                            {messages['troubleshootDevice_supportChat']}
                                                        </Button>
                                                    </Tooltip>
                                                </div>
                                            </div>
                                        )
                                    }
                                    {
                                        !installationValidation?.error &&
                                        !simCardSessionValidation?.error &&
                                        !simCardValidation?.error &&
                                        installationValidation?.data &&
                                        simCardSessionValidation?.data &&
                                        simCardValidation?.data &&
                                        (

                                            <div>
                                                <p style={{ fontSize: 13 }}>{messages['troubleshootDevice_validInstallationDate']}</p>
                                            </div>
                                        )
                                    }
                                </div>
                            )
                        }
                    </div>
                )
            }
        </div>
    )
}

export default ConnectionHistory